<script setup>
import BaseButton from "@/Components/UI/buttons/BaseButton.vue";

defineProps({
    submitText: {
        type: String,
        default: 'Сохранить'
    },
    errors: {
        type: Object,
        default: () => ({}),
    },
    active: {
        type: Boolean,
        default: true,
    },
    readOnly: {
        type: Boolean
    },
    noTitle: Boolean,
    submitImg: String,
})

defineEmits(['submit']);
</script>

<template>
    <form @submit.prevent="active && !readOnly && $emit('submit')">
        <div class="flex flex-col gap-5">
            <div v-if="!noTitle">
                <h3 class="text-base font-semibold">
                    <span class="text-xl">
                        <slot name="title"/>
                    </span>
                <slot name="subtitle"/>
                </h3>
            </div>
            <slot name="content"/>
        </div>
        <div class="flex flex-col justify-end gap-5 mt-10 md:flex-row pt-10 border-t border-light-1">
            <slot name="buttons"/>
            <BaseButton variant="primary"  v-if="!readOnly"
                                class="font-semibold"
                               :disabled="!active"
                               type="submit"
                               :img="submitImg"
                               img-position="right">
                {{ submitText }}
            </BaseButton>
        </div>
    </form>
</template>
